import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import browserHistory from 'components/utility/history';
import ConfigurationListView from '../view/ConfigurationListView';

class ConfigurationList extends React.Component {
	constructor(props) {
		super(props);
		this.loadDetail = this.loadDetail.bind(this);
	}

	loadDetail(item) {
		browserHistory.push(`${window.$conf.prefix}/project/configuration/${encodeURIComponent(item.name)}`);
	}

	render() {
		const { loading, error, errorDetail, configs } = this.props;
		if (error) {
			return <ErrorPage errorDetail={errorDetail} />;
		} else if (configs && !loading) {
			return (
				<ConfigurationListView
					items={configs}
					loadDetail={this.loadDetail}
				/>
			);
		}
		return <ContentLoading />;
	}
}

function mapStateToProps(state) {
	return {
		location: state.location.location,
		loading: state.config.loading,
		configs: state.config.configs,
		error: state.config.error,
		errorDetail: state.config.errorDetail
	};
}

ConfigurationList.propTypes = {
	configs: PropTypes.array,
	loading: PropTypes.bool,
	error: PropTypes.bool,
	errorDetail: PropTypes.object
};

export default connect(
	mapStateToProps,
	null
)(ConfigurationList);
